<template>
  <b-modal v-bind:id="modId" :title="this.$i18n.t('register.add_resultpanel')" hide-footer>
    <label for="inputMachine" class>{{ $i18n.t("register.machineID") }}</label>
    <b-form-input id="inputMachine" v-model="inputMachine" class="mb-3"></b-form-input>
    <b-button variant="primary" block @click='clickOk'>{{ $i18n.t("register.button_add") }}</b-button>
    <b-button block @click='clickCancel'>{{ $i18n.t("common.cancel") }}</b-button>
  </b-modal>
 </template>

<script>
export default {
  name: 'Modal',
  props: ['modId', 'inputMachine'],
  methods: {
    clickOk: function () {
      this.$parent.dispProcess = this.inputMachine
      this.confirmModal()
    },
    clickCancel: function () {
      this.$parent.dispProcess = ''
      this.$parent.editDispProcessFlg = 0
      this.confirmModal()
    },
    confirmModal () {
      this.$emit('confirm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegisterInputMachineModal.vue